export class StateEditor {
    value;
    selection;
    constructor(state) {
        this.value = state.value;
        this.selection = { start: state.selection?.start, end: state.selection?.end, direction: state.selection?.direction };
    }
    get(index, length = 1) {
        return this.value.substring(index, index + length);
    }
    is(index, ...character) {
        const c = this.get(index);
        return character.some(d => c == d);
    }
    isDigit(index) {
        const character = this.get(index);
        return character >= "0" && character <= "9";
    }
    match(matcher) {
        return this.value.match(matcher);
    }
    replace(start, end, value) {
        let result;
        if (typeof start == "string" && typeof end == "string") {
            let s;
            result = this;
            while ((s = result.value.indexOf(start)) > -1)
                result = result.replace(s, s + start.length, end);
        }
        else if (typeof start == "number" && typeof end == "number") {
            const state = {
                value: this.value,
                selection: { start: this.selection.start, end: this.selection.end, direction: this.selection.direction },
            };
            if (!value)
                value = "";
            state.value = this.value.slice(0, start) + value + this.value.slice(end, this.value.length);
            if (this.selection.start >= end)
                state.selection.start = this.selection.start + value.length - end + start;
            else if (this.selection.start > start && this.selection.start < end)
                state.selection.start = Math.min(this.selection.start, start + value.length);
            if (this.selection.end >= end)
                state.selection.end = this.selection.end + value.length - end + start;
            else if (this.selection.end > start && this.selection.end < end)
                state.selection.end = Math.min(this.selection.end, start + value.length);
            result = new StateEditor(state);
        }
        return result || this;
    }
    insert(index, value) {
        return this.replace(index, index, value);
    }
    append(value) {
        return this.insert(this.value.length, value);
    }
    prepend(value) {
        return this.insert(0, value);
    }
    suffix(value) {
        return new StateEditor({ value: this.value + value, selection: this.selection });
    }
    delete(start, end) {
        let result;
        if (!this.value)
            result = this;
        else if (typeof start == "string") {
            let s;
            result = this;
            while (start && (s = result.value.indexOf(start)) > -1)
                result = result.delete(s, s + start.length);
        }
        else
            result = this.replace(start, end || start + 1, "");
        return result;
    }
    truncate(end) {
        return this.value.length >= end ? this.delete(end, this.value.length) : this;
    }
    pad(length, padding, index) {
        let result = this;
        while (length > result.value.length + padding.length)
            result = result.insert(index, padding);
        if (length > result.value.length)
            result = result.insert(index, padding.substring(0, length - result.value.length));
        return result;
    }
    padEnd(length, padding) {
        return this.pad(length, padding, this.value.length);
    }
    padStart(length, padding) {
        return this.pad(length, padding, 0);
    }
    toLower() {
        return this.map(symbol => symbol.toLowerCase());
    }
    toUpper() {
        return this.map(symbol => symbol.toUpperCase());
    }
    map(mapping) {
        let result = this;
        let j = 0;
        for (let i = 0; i < this.value.length; i++) {
            const replacement = mapping(this.get(i), i);
            result = result.replace(j, j + 1, replacement);
            j += replacement.length;
        }
        return result;
    }
    static copy(state) {
        return new StateEditor({ ...state });
    }
    static create() {
        return new StateEditor({ value: "", selection: { start: 0, end: 0 } });
    }
    static modify(state) {
        return new StateEditor(typeof state == "string" ? { value: state, selection: { start: state.length, end: state.length } } : state);
    }
}
//# sourceMappingURL=StateEditor.js.map